import React from 'react';
import { TrashIcon, XMarkIcon } from '@heroicons/react/24/outline';

const DeleteConfirmation = ({
  cancel,
  removeComment,
  isDeleting,
}: {
  cancel: React.Dispatch<React.SetStateAction<boolean>>;
  removeComment: () => Promise<void>;
  isDeleting: boolean;
}) => {
  const handleDelete = async () => {
    try {
      await removeComment();
      cancel(false);
    } catch (error) {
      console.error('Failed to delete comment:', error);
    }
  };

  return (
    <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
      <div className="flex flex-col bg-grey p-10 rounded-3xl w-96 items-center">
        {isDeleting ? (
          <h1>Deleting ...</h1>
        ) : (
          <>
            <h1 className="text-lg">
              Definitely<span className="text-red"> delete </span>this comment?
            </h1>
            <div className="flex flex-row mt-5">
              <button
                className="flex flex-row justify-center items-center bg-white bg-opacity-10 text-white rounded-3xl px-5 py-2"
                onClick={() => cancel(false)}
              >
                <XMarkIcon className="w-4 h-4 mr-1" />
                Cancel
              </button>
              <button
                className="flex flex-row justify-center items-center bg-red text-black rounded-3xl px-5 py-2 ml-2"
                onClick={handleDelete}
              >
                Delete
                <TrashIcon className="w-4 h-4 ml-1" />
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default DeleteConfirmation;
